import React, { useState } from 'react';
import { Box, Typography, Button, CircularProgress, Alert, Container } from '@mui/material';
import COLORS from '../../../../constants/colors';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from './Header';
import baseURL from '../config';

const ResendVerifyEmailPage = () => {
  const [status, setStatus] = useState('idle'); // idle, sending, success, error
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const email = searchParams.get('email');

  const handleResendClick = async () => {
    if (!email) {
      setStatus('error');
      setMessage('Email is missing. Please go back and try again.');
      return;
    }

    setStatus('sending');
    setMessage('Sending verification email...');

    try {
      const response = await fetch(`${baseURL}/auth/user/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message || `Verification email has been sent to ${email}`);
      } else {
        setStatus('error');
        setMessage(data.message || 'Failed to send verification email.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('An error occurred. Please try again later.');
    }
  };

  return (
    <>
      <Header />

      <Box
        sx={{
          minHeight: '90vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          px: 2,
          bgcolor: COLORS.background || '#f9f9f9',
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              bgcolor: COLORS.white,
              boxShadow: 0,
              borderRadius: 3,
              p: 4,
              textAlign: 'center',
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={1}>
              Verify Your Email
            </Typography>
            <Typography variant="body1" color={COLORS.text} mb={3}>
              We noticed your email <strong>{email}</strong> is not verified.  
              Please verify to continue using your account.
            </Typography>

            {status === 'idle' && (
              <Button
                variant="contained"
                onClick={handleResendClick}
                sx={{
                  borderRadius: '10px',
                  py: 1,
                  fontSize: '0.9rem',
                  textTransform: 'none',
                  minWidth: 180,
                  backgroundColor: COLORS.primary,
                  color: COLORS.white,
                  boxShadow:0,
                }}
              >
                Resend Verification Email
              </Button>
            )}

            {status === 'sending' && (
              <>
                <CircularProgress size={24} color="primary" />
                <Typography variant="body1" color={COLORS.text} mt={2}>
                  {message}
                </Typography>
              </>
            )}

            {(status === 'success' || status === 'error') && (
              <>
                <Alert severity={status === 'success' ? 'success' : 'error'} sx={{ mb: 3 }}>
                  {message}
                </Alert>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/user/login')}
                  sx={{
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                    borderRadius: '10px',
                    py: 1,
                    fontSize: '0.9rem',
                    textTransform: 'none',
                    minWidth: 160,
                  }}
                >
                  Back to Login
                </Button>
              </>
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ResendVerifyEmailPage;
